function filterSearch(value,data) {
    const regex = new RegExp(value, 'i'); // 'i' for case-insensitive matching
    return data.filter(obj => {
      for (const key in obj) {
        if (regex.test(obj[key])) {
          return true;
        }
      }
      return false;
    });
}
export default filterSearch;